export default __webpack_public_path__ + "static/media/screenshot3.3a241c64.jpg";